import React from 'react';
import { Alert } from 'reactstrap';
import styles from '../Reimbursement.module.css';

export function AIGInverseAlert({ color, reason }) {
    return (
        <Alert
            color={color}
            className={styles.customAlert}
        >
            {reason}
        </Alert>
    );
}
